const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];

class dateTimeHelperClass
{
    dateFormatUSA(date, is_long = false) {
        var d:any = new Date(date);
        if (date === null || ! isFinite(d)) throw 'Invalid date';
        return this.getMonthByNum(d.getMonth(), is_long) + ' ' + d.getDate() + ', ' + d.getFullYear();
    }

    getMonthByNum(num, is_long = false) {
        return is_long ? monthNames[num] : monthNames[num].substr(0, 3);
    }

    get24Time(date, with_seconds = false) {
        var d:any = new Date(date);
        if (date === null || ! isFinite(d)) throw 'Invalid date';
        return this._zeroPad(d.getHours()) + ':' + this._zeroPad(d.getMinutes()) + (with_seconds ? ':' + this._zeroPad(d.getSeconds()) : '');
    }

    private _zeroPad(num, count = 2) {
        var num_str: any = num + '';
        return num_str.padStart(count, '0');
    }
}

export let dateTimeHelper = new dateTimeHelperClass();



// WEBPACK FOOTER //
// ./src/app/helpers/date.ts